

<app-daily-detail [type] = '"fresh"' [subject] = '"Story"' > </app-daily-detail>

<div  *ngIf="false">
<div class="text-center">story-of-the-day</div>
<div class="embed-responsive embed-responsive-16by9">
    <iframe class="embed-responsive-item" [src]="(utube + utubeId)|safe:'resourceUrl'" allowfullscreen></iframe>
  </div>
</div>